import React from "react"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import Login from "./pages/Login"
import Register from "./pages/Register"
import MarketplaceItemDetails from "./pages/Marketplace/MarketplaceItemDetails"
import { AuthProvider } from './context/authContext'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import PrivateRoute from "./components/PrivateRoute"
import SidebarChat from "./components/sidebars/SidebarChat"
import SidebarIndividualChat from "./components/sidebars/SidebarIndividualChat"
import Dashboard from "./pages/Dashboard"
import CategoryManagement from "./pages/CategoryManagement"
import BoxTypeManagement from "./pages/BoxTypeManagement"
import ConditionManagement from "./pages/ConditionManagement"
import UserManagement from "./pages/UserManagement"
import ListingManagement from "./pages/ListingManagement"
import ShopifyManagement from "./pages/ShopifyManagement"
import SupportManagement from "./pages/SupportManagement"
import PublicProfile from "./pages/PublicProfile"
import IncomeManagement from "./pages/IncomeManagement"
import { subAdminPrivilege } from "./utils/data"
import SubAdminManagement from "./pages/SubAdminManagement"
import EmailSupportManagement from "./pages/EmailSupportManagement"


function App() {
  return (
    <AuthProvider>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={true}
        draggable={true}
        style={{ zIndex: 100000 }}
      />

      <SidebarChat />
      <SidebarIndividualChat />

      <Router>
        {/* <Navigator /> */}
        <Routes>
          <Route path="/" element={<PrivateRoute privileges = {[]} element={<Dashboard />} />} />
          <Route path="/category" element={<PrivateRoute privileges={[subAdminPrivilege.CATEGORY_MANAGER]} element={<CategoryManagement />} />} />
          <Route path="/boxType" element={<PrivateRoute privileges={[subAdminPrivilege.BOX_TYPE_MANAGER]} element={<BoxTypeManagement />} />} />
          <Route path="/condition" element={<PrivateRoute element={<ConditionManagement />} />} />
          <Route path="/user" element={<PrivateRoute element={<UserManagement />} />} />
          <Route path="/sub-admin" element={<PrivateRoute element={<SubAdminManagement />} />} />
          <Route path="/listing" element={<PrivateRoute privileges={[subAdminPrivilege.LISTING_MANGER]} element={<ListingManagement />} />} />
          <Route path="/shopify" element={<PrivateRoute privileges={[subAdminPrivilege.LISTING_MANGER]} element={<ShopifyManagement />} />} />
          <Route path="/support" element={<PrivateRoute privileges={[subAdminPrivilege.SUPPORT_MANAGER]} element={<SupportManagement />} />} />
          <Route path="/email-support" element={<PrivateRoute privileges={[subAdminPrivilege.SUPPORT_MANAGER]} element={<EmailSupportManagement />} />} />
          <Route path="/incomes" element={<PrivateRoute element={<IncomeManagement />} />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/marketplace/:cardId"
            element={<PrivateRoute element={<MarketplaceItemDetails />} containLayout={false} />}
          />

          <Route
            path="/user-profile/:userId"
            element={<PrivateRoute element={<PublicProfile />} containLayout={false} />}
          />
          
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
